import { z } from 'zod';
export const InviteCodeSchema = z
    .string()
    .trim()
    .min(4)
    .max(64)
    .regex(/^[A-Za-z0-9-]+$/, 'Invite codes may only contain letters, digits, and dashes');
export const ClaimInviteRequestSchema = z.object({
    code: InviteCodeSchema,
    pendingToken: z.string().min(1).max(2048).optional(),
});
export const AuthErrorCodeSchema = z.enum([
    'invalid_invite_code',
    'invite_code_exhausted',
    'pending_expired',
    'pending_missing',
    'origin_blocked',
    'rate_limited',
    'unauthorized',
    'unknown',
]);
//# sourceMappingURL=auth.js.map